import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\SquareUp\GetLocationListController::__invoke
* @see app/Http/Controllers/SquareUp/GetLocationListController.php
* @route '/api/site/{site}/square-up/get-location'
*/
const GetLocationListController = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationListController.url(args, options),
    method: 'get',
})

GetLocationListController.definition = {
    methods: ["get","head"],
    url: '/api/site/{site}/square-up/get-location',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SquareUp\GetLocationListController::__invoke
* @see app/Http/Controllers/SquareUp/GetLocationListController.php
* @route '/api/site/{site}/square-up/get-location'
*/
GetLocationListController.url = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { site: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { site: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            site: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        site: typeof args.site === 'object'
        ? args.site.id
        : args.site,
    }

    return GetLocationListController.definition.url
            .replace('{site}', parsedArgs.site.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SquareUp\GetLocationListController::__invoke
* @see app/Http/Controllers/SquareUp/GetLocationListController.php
* @route '/api/site/{site}/square-up/get-location'
*/
GetLocationListController.get = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetLocationListController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SquareUp\GetLocationListController::__invoke
* @see app/Http/Controllers/SquareUp/GetLocationListController.php
* @route '/api/site/{site}/square-up/get-location'
*/
GetLocationListController.head = (args: { site: string | number | { id: string | number } } | [site: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetLocationListController.url(args, options),
    method: 'head',
})

export default GetLocationListController